/**
 * defa.collections.ZoneHolders
 * A Collection of ZoneHolders
 * @version 1.2.0
 */
import ZoneHolder from './model-zone-holder';

const ZoneHolders = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : ZoneHolder,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

} );


export default ZoneHolders